import React, { useState,useEffect } from "react";
import {
  DialogContent,
  CardContent,
  Card,
  Grid,
  makeStyles,
  TableContainer,Table,TableHead,TableRow,TableCell,TableBody,Button
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import Colors from "shared/color";
import TableBodyCell from "components/table/TableBodyCell";
import {autoDisbursementDisbursement,retryDisburse} from '../../../../shared/api/purple/autoDisbursement'
import { toastError, toastSuccess } from "shared/utils";
import { PERMISSIONS, ROUTE_NAME } from 'shared/constants';
import KisshtButton from "components/ui/KisshtButton";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
let txn;
export const DisburseModel = (props) => {
  const { visible, callbackEvent} = props;
  const classes = useStyles();
  const [disbursalModalData ,setDisbursalModalData] = useState()
  const [outboundDetails, setOutboundDetails] = useState([])
  const [disburseStatus,setDisburseStatus] = useState()

  const disbursement_status = props.data?.disbursement_status

  const fetchDisburseData = async () =>{
    const disbursementReferenceNumber = props.data?.disbursement_reference_number

    autoDisbursementDisbursement(disbursementReferenceNumber)
    .then((res) =>{
      if(res.message === "Success")
      {
        setDisbursalModalData(res.data.disbursement_details);
        setOutboundDetails(res.data.outbound_details)
      }
    })
  }
  const fetchRetryDisburseData = async () =>{
    txn = outboundDetails[0]?.transaction_reference_number;
    let data = {
      "transaction_reference_number":txn
    }
    retryDisburse(data)
    .then((res) =>{
      setDisburseStatus(res.data.status)
      if(res.data.status === "failed")
      {
        toastError(res.data.message)        // setDisbursalModalData(res.data.disbursement_details);
        // setOutboundDetails(res.data.outbound_details)
      }
      else{
         props.callbackEvent();
        toastSuccess(res.data.message)
        window.location.reload();
      }
    })
  }


  useEffect(() =>{
    fetchDisburseData()
    // eslint-disable-next-line
  },[])

  let renderBody = () => {
    if(outboundDetails?.length < 1){
      return <div className='global_center'> No records found.</div>
  }
    return outboundDetails?.map((item) => {

      return(
        <TableRow>
          <TableCell  style={{textAlign:"center"}}>{item.disbursement_reference_number || "-"}	</TableCell>
          <TableCell  style={{textAlign:"center"}}>{item.disbursement_status || "-"}</TableCell>
          <TableCell  style={{textAlign:"center"}}>{item.outbound_reference_number || "-"}	</TableCell>
          <TableCell  style={{textAlign:"center"}}>{item.outbound_status || "-"}</TableCell>
          <TableCell  style={{textAlign:"center"}}>{item.response_key || "-"}</TableCell>
          <TableCell  style={{textAlign:"center"}}>{item.reconciliation_status || "-"}</TableCell>
          <TableCell  style={{textAlign:"center",width:"200px"}}>{item.disb_created_at || "-"}</TableCell>
          <TableCell  style={{textAlign:"center",width:"200px"}}>{item.out_created_at || "-"}</TableCell>
        </TableRow>
      )
    })
    
  }
return (
    <Spin>
      <KisshtDialog
        title={"Disbursement Details"}
        maxWidth={"xl"}
        open={visible}
        handleClose={callbackEvent}
      >
        <DialogContent>
      <Card style={{ boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`}} className={classes.card}>
        <CardContent className="p-1">
          <Grid container>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Grid item xs={12}>
                  <CardContent  style={{border:"solid 0.4px gray"}}>
              <TableContainer className="common_X_scroll">
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
              <TableHead >
                    
              </TableHead>
              {disbursalModalData?.map((item) =>{
                return <TableBody>
                <TableRow>
                <TableBodyCell className="font-semibold" >Disbursement Reference Number	</TableBodyCell>
                  <TableBodyCell>{item.disbursement_reference_number || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >Transaction Reference Number</TableBodyCell>
                  <TableBodyCell>{item.transaction_reference_number || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >Settlement Reference Number	</TableBodyCell>
                  <TableBodyCell>{item.settlement_reference_number || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >User Bank Reference Number	</TableBodyCell>
                  <TableBodyCell>{item.user_bank_reference_number || "-"}</TableBodyCell>
                </TableRow>
                 <TableRow>
                 <TableBodyCell className="font-semibold" >Amount	</TableBodyCell>
                  <TableBodyCell>{item.amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >Beneficiary Type	</TableBodyCell>
                  <TableBodyCell>{item.beneficiary_type}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >Payment Type	</TableBodyCell>
                  <TableBodyCell>{item.payment_type || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                <TableBodyCell className="font-semibold" >Type Reference Number	</TableBodyCell>
                  <TableBodyCell>{item.type_reference_number || "-"}</TableBodyCell>
                </TableRow>
              </TableBody>

              })}
                </Table>
              </TableContainer> 
            </CardContent>
          
                </Grid>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Grid item xs={12}>
                  <CardContent  style={{border:"solid 0.4px gray"}}>
              <TableContainer className="common_X_scroll">
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
              <TableHead >
                    
              </TableHead>
              {disbursalModalData?.map((item) =>{
                  return <TableBody>
                  <TableRow>
                    <TableBodyCell className="font-semibold" >Response Code	</TableBodyCell>
                      <TableBodyCell>{item.response_code || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Response Message	</TableBodyCell>
                      <TableBodyCell>{item.response_message || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Payment Mode	</TableBodyCell>
                      <TableBodyCell>{item.payment_mode || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Bank Name	</TableBodyCell>
                      <TableBodyCell>{item.bank_name || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Created At</TableBodyCell>
                      <TableBodyCell>{item.created_at || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Updated At	</TableBodyCell>
                      <TableBodyCell>{item.updated_at || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Retry Time</TableBodyCell>
                      <TableBodyCell>{item.retry_time || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Retry Status</TableBodyCell>
                      <TableBodyCell>{item.retry_status || "-"}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                    <TableBodyCell className="font-semibold" >Disbursement Status	</TableBodyCell>
                      <TableBodyCell>{item.disbursement_status || "-"}</TableBodyCell>
                    </TableRow>
                  </TableBody>
                    })}
                </Table>
              </TableContainer> 
            </CardContent>
          
                </Grid>
              </Grid>
          </Grid>
        </CardContent>
        {/* {retryButton == true ? 
        <> */}
        {
         disbursement_status === "FAILURE" && outboundDetails[0]?.outbound_status !== "PENDING" && disburseStatus !== "failed"?
         <>
          <CardContent>
          <Grid>
            <KisshtButton
                size="small"
                variant="contained"
                className="shadow-none"
                color="primary"
                style={{textAlign:"center",float:"right",marginBottom:'-40px'}}
                onClick={() => fetchRetryDisburseData()}
                route={ROUTE_NAME.auto_disbursement}
                permission={PERMISSIONS.auto_disbursement.retry_disbursement}
            >
                ReTry Disbursal
            </KisshtButton>
          </Grid>
          </CardContent> 
          </>
          : 
          null
        }
        {/* </>
        : null} */}
        {disburseStatus === "failed" ? 
           <CardContent>
           <Grid>
             <Button
              size="small"
              variant="contained"
              className="shadow-none"
              style={{textAlign:"center",float:"right",marginBottom:'10px',background:"red",color:"#fff"}}
             >DISBURSE</Button>
           </Grid>
           </CardContent> 
          :
          <Grid >
          <h1 style={{textAlign:"left",textTransform:"uppercase",padding:"2px",fontSize:"16px"}}>Disbursement History</h1>
          <CardContent  style={{border:"solid 0.4px gray"}}>
          <TableContainer className="common_X_scroll">
          <Table striped className="" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
          <TableHead>
           <TableRow>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Disburse Ref No.	</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Disburse status	</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Outbound Ref No.	</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Outbound status	</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Response key</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Reconciliation status	</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Disbursement</TableCell>
                    <TableCell  style={{textTransform:"uppercase",textAlign:"center"}} className="font-semibold">Outbound</TableCell>

           </TableRow>
          </TableHead>
             <TableBody>
              {renderBody()}
              </TableBody>
            </Table>
          </TableContainer> 
          </CardContent> 
        </Grid>
            }
            
      </Card>
           
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};

export default DisburseModel;
